import Typography from '@mui/material/Typography';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchTaskCard } from 'shared/components/connected/search-task-card';
import { useFocusChildrenWithArrows } from 'shared/hooks/use-focus-children-with-arrows';
import { useTextFilteredTasks } from 'shared/hooks/use-text-filtered-tasks';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { ActionEvents } from 'shared/services/tracking';

import * as Styled from './search-results.style';

export type SearchResultsProps = {
  searchValue: string;
  onClose: () => void;
};

export const SearchResults: React.FC<SearchResultsProps> = ({
  searchValue,
  onClose,
}) => {
  const track = useTrackEvents();
  const listRef = useRef<HTMLUListElement>(null);
  const { t } = useTranslation();
  const tasks = useTextFilteredTasks(searchValue);

  const _onClose = () => {
    track(ActionEvents.SearchResultClicked, undefined);
    onClose();
  };

  useFocusChildrenWithArrows(listRef, {
    querySelectors: ['[tabindex]:not([tabindex="-1"])'],
  });

  return tasks.length ? (
    <Styled.ResultsContainer>
      <Styled.Title>{t('dialogs.search.list.title.tasks')}</Styled.Title>
      <Styled.List ref={listRef}>
        {tasks.map((task) => (
          <Styled.ListItem key={task.id}>
            <SearchTaskCard task={task} onClick={_onClose} tabbable />
          </Styled.ListItem>
        ))}
      </Styled.List>
    </Styled.ResultsContainer>
  ) : (
    <Styled.EmptyContainer>
      <Typography variant="subtitle1">
        {t('general.labels.search.no-results')}
      </Typography>
    </Styled.EmptyContainer>
  );
};
